export default __webpack_public_path__ + "static/media/coach-bundle_gray@2x.a00a06aa.webp";